<template>
  <div class="devices-container">
    <el-card class="filter-card">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="仪器名称">
          <el-input v-model="filterForm.deviceName" placeholder="请输入仪器名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="所属商家">
          <el-select 
            v-model="filterForm.merchantId" 
            placeholder="请选择商家" 
            filterable 
            clearable
            style="width: 200px">
            <el-option
              v-for="item in merchantOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filterForm.status" placeholder="请选择" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="正常" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="resetFilter">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="table-card">
      <div class="table-header">
        <div class="header-left">
          <span class="title">仪器列表</span>
          <span class="count">共 {{ totalItems }} 条</span>
        </div>
        <div class="header-right">
          <el-button type="success" icon="el-icon-plus" @click="handleAddDevice">新增仪器</el-button>
        </div>
      </div>
      
      <el-table
        :data="deviceList"
        border
        v-loading="loading"
        style="width: 100%">
        <template slot="empty">
          <div class="empty-block">
            <p class="empty-text">{{ loading ? '加载中...' : '暂无数据' }}</p>
          </div>
        </template>
        <el-table-column
          type="index"
          label="序号"
          width="60">
        </el-table-column>
        <el-table-column
          prop="deviceName"
          label="仪器名称"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="deviceModel"
          label="仪器型号"
          min-width="120">
        </el-table-column>
        <el-table-column
          label="所属商家"
          min-width="150">
          <template slot-scope="scope">
            {{ getMerchantName(scope.row.merchantId) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="price"
          label="测试价格"
          width="100">
          <template slot-scope="scope">
            {{ scope.row.price }}元
          </template>
        </el-table-column>
        <el-table-column
          prop="deviceCount"
          label="仪器数量"
          width="100">
          <template slot-scope="scope">
            {{ scope.row.deviceCount }}台
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
              {{ scope.row.status === 1 ? '正常运行' : '已禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="120">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="pageSize"
          :total="totalItems"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </el-card>

    <!-- 新增/编辑仪器弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="deviceForm" :rules="rules" ref="deviceForm" label-width="100px">
        <el-form-item label="仪器名称" prop="deviceName">
          <el-input v-model="deviceForm.deviceName" placeholder="请输入仪器名称"></el-input>
        </el-form-item>
        <el-form-item label="仪器型号" prop="deviceModel">
          <el-input v-model="deviceForm.deviceModel" placeholder="请输入仪器型号"></el-input>
        </el-form-item>
        <el-form-item label="所属商家" prop="merchantId">
          <el-select
            v-model="deviceForm.merchantId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词搜索商家"
            :remote-method="searchMerchants"
            :loading="loading"
            style="width: 100%">
            <el-option
              v-for="item in merchantOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="测试价格" prop="price">
          <div class="input-with-unit">
            <el-input v-model.number="deviceForm.price" type="text" placeholder="请输入单个样品价格" style="width: 100%">
              <template slot="append">元</template>
            </el-input>
          </div>
        </el-form-item>
        <el-form-item label="仪器数量" prop="deviceCount">
          <div class="input-with-unit">
            <el-input v-model.number="deviceForm.deviceCount" type="text" placeholder="请输入仪器数量" style="width: 100%">
              <template slot="append">台</template>
            </el-input>
          </div>
        </el-form-item>
        <el-form-item v-if="editingIndex !== -1" label="仪器状态" prop="status">
          <el-switch
            v-model="deviceForm.status"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="禁用">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitting">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'Devices',
  data() {
    return {
      filterForm: {
        deviceName: '',
        merchantId: '',
        status: ''
      },
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      deviceList: [],
      merchantOptions: [],
      merchants: [],
      loading: false,
      submitting: false,
      dialogVisible: false,
      dialogTitle: '新增仪器',
      editingIndex: -1, // -1表示新增，>=0表示编辑
      deviceForm: {
        deviceName: '',
        deviceModel: '',
        merchantId: '',
        price: 0,
        deviceCount: 1,
        status: 1
      },
      rules: {
        deviceName: [
          { required: true, message: '请输入仪器名称', trigger: 'blur' }
        ],
        deviceModel: [
          { required: true, message: '请输入仪器型号', trigger: 'blur' }
        ],
        merchantId: [
          { required: true, message: '请选择所属商家', trigger: 'change' }
        ],
        price: [
          { required: true, message: '请输入测试价格', trigger: 'blur' },
          { type: 'number', message: '测试价格必须为数字', trigger: 'blur' }
        ],
        deviceCount: [
          { required: true, message: '请输入仪器数量', trigger: 'blur' },
          { type: 'number', message: '仪器数量必须为数字', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // 加载商家列表
    this.fetchMerchantList();
    // 加载仪器列表
    this.fetchDevices();
  },
  methods: {
    // 获取仪器列表
    async fetchDevices() {
      try {
        this.loading = true;
        const params = {
          page: this.currentPage,
          limit: this.pageSize,
          deviceName: this.filterForm.deviceName || null,
          merchantId: this.filterForm.merchantId || null,
          status: this.filterForm.status === '' ? null : this.filterForm.status
        };
        
        const response = await adminApi.getDeviceListByPage(params);
        if (response && response.data) {
          this.deviceList = Array.isArray(response.data.data) ? response.data.data : [];
          this.totalItems = response.data.count || 0;
        } else {
          this.deviceList = [];
          this.totalItems = 0;
          this.$message.error('获取仪器列表失败');
        }
      } catch (error) {
        this.deviceList = [];
        this.totalItems = 0;
        this.$message.error('获取仪器列表失败：' + (error.message || '未知错误'));
        console.error('获取仪器列表失败:', error);
      } finally {
        this.loading = false;
      }
    },
    // 获取商家列表
    async fetchMerchantList() {
      try {
        this.loading = true;
        const merchants = await adminApi.getMerchantList();
        if (merchants && Array.isArray(merchants)) {
          this.merchants = merchants;
          this.merchantOptions = merchants.map(item => {
            return { value: item.id, label: item.companyName };
          });
        }
      } catch (error) {
        this.$message.error('获取商家列表失败：' + (error.message || '未知错误'));
        console.error('获取商家列表失败:', error);
      } finally {
        this.loading = false;
      }
    },
    handleFilter() {
      this.currentPage = 1;
      this.fetchDevices();
    },
    resetFilter() {
      this.filterForm = {
        deviceName: '',
        merchantId: '',
        status: ''
      };
      this.handleFilter();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.fetchDevices();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.fetchDevices();
    },
    handleAddDevice() {
      this.dialogTitle = '新增仪器';
      this.editingIndex = -1;
      this.resetForm();
      this.dialogVisible = true;
    },
    handleEdit(device) {
      this.dialogTitle = '编辑仪器';
      this.editingIndex = 1; // 标记为编辑模式
      
      // 复制当前仪器数据到表单
      this.deviceForm = { ...device };
      this.dialogVisible = true;
    },
    resetForm() {
      this.deviceForm = {
        deviceName: '',
        deviceModel: '',
        merchantId: '',
        price: 0,
        deviceCount: 1,
        status: 1
      };
      if (this.$refs.deviceForm) {
        this.$refs.deviceForm.resetFields();
      }
    },
    async submitForm() {
      this.$refs.deviceForm.validate(async valid => {
        if (valid) {
          try {
            this.submitting = true;
            
            if (this.editingIndex === -1) {
              // 新增仪器 - 调用新增仪器接口
              await adminApi.addDevice(this.deviceForm);
              this.$message.success('新增仪器成功');
            } else {
              // 编辑仪器 - 调用更新仪器接口
              await adminApi.updateDevice(this.deviceForm);
              this.$message.success('编辑仪器成功');
            }
            
            this.dialogVisible = false;
            // 刷新仪器列表
            this.fetchDevices();
          } catch (error) {
            this.$message.error((this.editingIndex === -1 ? '新增' : '编辑') + '仪器失败：' + (error.message || '未知错误'));
            console.error('仪器操作失败:', error);
          } finally {
            this.submitting = false;
          }
        } else {
          return false;
        }
      });
    },
    searchMerchants(query) {
      if (query !== '') {
        this.merchantOptions = this.merchants.filter(item => {
          return item.companyName && item.companyName.toLowerCase().includes(query.toLowerCase());
        }).map(item => {
          return { value: item.id, label: item.companyName };
        });
      } else {
        this.merchantOptions = this.merchants.map(item => {
          return { value: item.id, label: item.companyName };
        });
      }
    },
    getMerchantName(merchantId) {
      const merchant = this.merchants.find(item => item.id === merchantId);
      return merchant ? merchant.companyName : merchantId;
    }
  }
}
</script>

<style scoped>
.devices-container {
  padding: 20px 0;
}

.filter-card {
  margin-bottom: 20px;
}

.filter-form {
  display: flex;
  flex-wrap: wrap;
}

.table-card {
  margin-bottom: 20px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-left {
  display: flex;
  align-items: center;
}

.title {
  font-size: 18px;
  font-weight: bold;
  margin-right: 10px;
}

.count {
  color: #909399;
  font-size: 14px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.empty-block {
  padding: 30px 0;
  text-align: center;
}

.empty-text {
  color: #909399;
  font-size: 14px;
}

.input-with-unit {
  display: flex;
  align-items: center;
  width: 100%;
}
</style>
